import { c as _c } from "react/compiler-runtime";
export default function Play(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M22.983 14.301c.9.5 1.299 1.599.8 2.598-.2.4-.5.7-.8.8l-11.787 6.493c-.998.6-2.297.3-2.896-.699-.2-.3-.3-.6-.3-.999V9.506c.096-1.147 1.014-2.02 2.142-2.006l.155.008c.3 0 .7.1 1 .3L22.982 14.3z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}